import { toggleMarkWithAttrs, isCustomMarkActive } from "../../../commands/custom-commands";
import { customSchema } from "../../../schemas/custom-schema";

export default class InlineCodeButton {
	constructor(editorView, containerElement) {
		this.view = editorView;
		this.buttonElement = document.createElement("button");
		this.buttonElement.setAttribute("type", "button");
		this.buttonElement.className = "editor-toolbar-button";
		this.buttonElement.setAttribute("type", "button");
		this.buttonElement.dataset.action = "code";
		this.buttonElement.title = "Código en línea";
		const iconSpan = document.createElement("span"),
			labelSpan = document.createElement("span");
		iconSpan.textContent = "Código en línea";
		labelSpan.className = "oculto-visual";
		labelSpan.textContent = "Código en línea";
		this.buttonElement.appendChild(iconSpan);
		this.buttonElement.appendChild(labelSpan);

		this.action = this.buttonClickCallback();
		this.rejectFocusAction = this.buttonMouseDownCallback();
		this.buttonElement.addEventListener("click", this.action);
		this.buttonElement.addEventListener("mousedown", this.rejectFocusAction);
		containerElement.appendChild(this.buttonElement);
		this.update(editorView);
	}

	update(view) {
		const isActive = isCustomMarkActive(view.state, customSchema.marks.inlineCode) ? "true" : "false",
			isEnabled = toggleMarkWithAttrs(customSchema.marks.inlineCode)(view.state, null);
		this.buttonElement.setAttribute("aria-pressed", isActive);
		this.buttonElement.disabled = !isEnabled;
		this.view = view;
	}

	destroy() {
		this.buttonElement.removeEventListener("click", this.action);
		this.buttonElement.removeEventListener("mousedown", this.rejectFocusAction);
		this.buttonElement.remove();
		this.buttonAction = null;
		this.rejectFocusAction = null;
		this.buttonElement = null;
		this.view = null;
	}

	buttonMouseDownCallback() {
		return (event) => {
			event.preventDefault();
		}
	}

	buttonClickCallback() {
		return () => {
			toggleMarkWithAttrs(customSchema.marks.inlineCode)(this.view.state, this.view.dispatch);
		}
	}
}